import React from "react";
import { connect, compose, useSelector, useStore } from 'react-redux';
import cx from "classnames";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import Hidden from "@material-ui/core/Hidden";
import Box from "@material-ui/core/Box";
import Button from "components/CustomButtons/Button.js";

// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";

import routes from "routes.js";

import styles from "assets/jss/material-dashboard-pro-react/layouts/adminStyle.js";

import { authService } from "services/authService.js";
import apiService from "services/apiService.js";
import config from "constants/config.js";
import storeConstants from "constants/storeConstants.js";

var ps;

const useStyles = makeStyles(styles);

const Dashboard = function(props) {
  const { ...rest } = props;
  // states and functions
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [miniActive, setMiniActive] = React.useState(false);
  const [image, setImage] = React.useState(require("assets/img/sidebar-2.jpg"));
  const [color, setColor] = React.useState("blue");
  const [bgColor, setBgColor] = React.useState("black");
  // const [hasImage, setHasImage] = React.useState(true);
  const [fixedClasses, setFixedClasses] = React.useState("dropdown");
  const [logo, setLogo] = React.useState(require("assets/img/logo.png"));
  const mlogo = require("assets/img/logo.png");

  const [investmentName, setInvestmentName] = React.useState("");

  // const [activated, setActivated] = React.useState(false);

  const store = useStore();
  const { account } = store.getState().accountInfo;
  const activated = account.activated;

  useSelector(state => {
    const {name} = state.accountInfo.account;
    // console.log(state.accountInfo.account);
    if (name !== "" && name !== investmentName) {
      setInvestmentName(name);
    }
  });
  // styles
  const classes = useStyles();
  const mainPanelClasses =
    classes.mainPanel +
    " " +
    cx({
      [classes.mainPanelSidebarMini]: miniActive,
      [classes.mainPanelWithPerfectScrollbar]:
        navigator.platform.indexOf("Win") > -1
    });
  // ref for main panel div
  const mainPanel = React.createRef();

  const [accountList, setAccountList] = React.useState([]);

  const [investmentTypeArr, setInvestmentTypeArr] = React.useState([]);
  // effect instead of componentDidMount, componentDidUpdate and componentWillUnmount
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);

    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  });

  // functions for changeing the states from components
  const handleImageClick = image => {
    setImage(image);
  };
  const handleColorClick = color => {
    setColor(color);
  };
  const handleBgColorClick = bgColor => {
    switch (bgColor) {
      case "white":
        setLogo(require("assets/img/logo.svg"));
        break;
      default:
        setLogo(require("assets/img/logo-white.svg"));
        break;
    }
    setBgColor(bgColor);
  };
  const handleFixedClick = () => {
    if (fixedClasses === "dropdown") {
      setFixedClasses("dropdown show");
    } else {
      setFixedClasses("dropdown");
    }
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/dashboard/full-screen-maps";
  };
  const getActiveRoute = routes => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  const getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/dashboard") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  const sidebarMinimize = () => {
    setMiniActive(!miniActive);
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  const brandText = (investmentName) => {
    
    // if (props.location.pathname === "/dashboard/account")
    //   return "Account Management";

    // if (props.location.pathname.includes( "/dashboard/investments/details/"))
    //   return investmentName.toUpperCase() + " | Investment Details";

    // if (props.location.pathname === "/dashboard/documents")
    //   return investmentName.toUpperCase() + " | Documents";

    // if (props.location.pathname === "/dashboard/overview")
    //   return investmentName.toUpperCase() + " | Overview";

    // if (props.location.pathname === "/dashboard/activities")
    //   return investmentName.toUpperCase() + " | Activity";

    // if (props.location.pathname === "/dashboard/transactions")
    //   return investmentName.toUpperCase() + " | Transactions";

    // if (props.location.pathname === "/dashboard/capitalcalls")
    //   return investmentName.toUpperCase() + " | Capital Calls";

    // if (props.location.pathname === "/dashboard/performance")
    //   return investmentName.toUpperCase() + " | Performance";

    // if (props.location.pathname.includes("/dashboard/activate"))
    //   return "ACCOUNT MANAGEMENT";

    // if (props.location.pathname === "/dashboard/support")
    //   return "SUPPORT";

    // if (props.location.pathname === "/dashboard/terms")
    //   return "SUPPORT | Definitions";

    // if (props.location.pathname === "/dashboard/contact")
    //   return "SUPPORT | Contact Us";

    // return investmentName.toUpperCase() + " | Investments";
    return "Teleplay Admin";
  }

  const PendingBar = () => {
    return (
      <Box className={classes.pendingBar}>
        <p>Your account is pending. Please complete your signature form to finalize your account setup.</p>
        <Button className={classes.pendingButton} onClick={e => {
          console.log(account);
          apiService(config.endpoint.addAccount + "/" + account._id + "/signnow", "POST", {}, function(response) {
            props.history.push("/dashboard/activate/" + account._id + "?helloSign=" + response.embeddedSigningUrl);
          }, function(error) {
            console.log(error);
          }, authService.getToken());
        }}>Complete Setup</Button>
      </Box>
    )
  }

  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        logoText={"Teleplay"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        bgColor={bgColor}
        miniActive={miniActive}
        accountList={accountList}
        investmentTypeArr={investmentTypeArr}
        {...rest}
      />
      <div className={mainPanelClasses} ref={mainPanel}>
        {!activated && (<Hidden smDown>
          <PendingBar />
        </Hidden>)}
        <AdminNavbar
          sidebarMinimize={sidebarMinimize.bind(this)}
          miniActive={miniActive}
          // brandText={getActiveRoute(routes)}
          brandText={brandText(investmentName)}
          handleDrawerToggle={handleDrawerToggle}
          logo={mlogo}
          {...rest}
        />
        {!activated && (<Hidden mdUp>
          <PendingBar />
        </Hidden>
        )}
        {/* On the /maps/full-screen-maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>
              <Switch>
                {getRoutes(routes)}
                <Redirect from="/dashboard" to="/dashboard/accounts" />
              </Switch>
            </div>
          </div>
        ) : (
          <div className={classes.map}>
            <Switch>
              {getRoutes(routes)}
              <Redirect from="/dashboard" to="/dashboard/accounts" />
            </Switch>
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  name: state.name,
  _id: state._id
})

export default connect(
  mapStateToProps
)(Dashboard);
// export default Dashboard;